const layersLoadedReducer = (state = null, action) => {
  switch(action.type) {
    case 'LAYERS_LOADED':
      return action.payload;
    default:
      return state
    }
  }

  export default layersLoadedReducer;